import { ITipoTelefone } from "../../../Interfaces/Geral/TipoTelefone/TipoTelefoneInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export const ListarTipoTelefoneService = () =>
    Service(
        Axios.get<Array<ITipoTelefone>>(`/home/tipotelefone/listartipotelefone`)
    );
